module.exports = __webpack_public_path__ + "img/canada.5e1584fe.png";